import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { LabelI18nService } from 'src/app/core/_services/label-i18n.service';
import { MatCheckboxChange } from '@angular/material/checkbox';
import * as Highcharts from 'highcharts';
import HC_exporting from 'highcharts/modules/exporting';
import HC_offlineExporting from 'highcharts/modules/offline-exporting';
import sunburst from 'highcharts/modules/sunburst.js';
import { IndicatorCodes } from 'src/app/core/_enums/indicators.code';
import { SationImpactColor } from 'src/app/core/_enums/station.impact.color';
import { Impact } from 'src/app/core/_models/impact';
import { Indicator } from 'src/app/core/_models/indicator';
import { ProjectEcoPro } from 'src/app/core/_models/projectEcoPro';
import { SolutionEcoPro } from 'src/app/core/_models/solutionEcoPro';
import { Structure } from 'src/app/core/_models/structure';
import { HIGHCHARTS_EXPORTING, HIGHCHARTS_TRANSLATIONS } from 'src/constants/graph.constants';
sunburst(Highcharts);
HC_exporting(Highcharts);
HC_offlineExporting(Highcharts);

@Component({
  selector: 'app-sunburst-indicators-byStations',
  templateUrl: './sunburst-indicators-byStations.component.html',
  styleUrls: ['./sunburst-indicators-byStations.component.scss']
})
export class SunburstIndicatorsByStationsComponent implements OnChanges, OnInit {
  @Input() projectData: ProjectEcoPro = {};
  @Input() indicators: Indicator[] = [];
  @Input() isEcoPro: boolean = true;
  @Input() synthese: any;
  structures: Structure[] = [];

  indicatorComparatif: Indicator = {
    isChecked: false,
    displayName: ''
  };

  solutionComparatif: SolutionEcoPro = { structureTypesProject: [] };
  solutionComparatifProjet: any = {};
  private defaultApplied = false;
  updateFlag: boolean = false;
  totalRef: number = 0;
  solutions: any[] = [];
  selectedSolution: string = '';

  // Highcharts config

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions: Highcharts.Options = {
    title: {
      text: 'Détail par scénario et module'
    },
    lang: HIGHCHARTS_TRANSLATIONS,
    exporting: HIGHCHARTS_EXPORTING
  };

  constructor(public labelI18n: LabelI18nService) {}

  ngOnChanges() {
    if (this.isEcoPro) {
      let solutionComparative: SolutionEcoPro | undefined = this.projectData?.solutionsEcoPro?.find((solution: SolutionEcoPro) => solution.solutionEcoProId == this.solutionComparatif.solutionEcoProId);

      if (this.indicatorComparatif && this.solutionComparatif && solutionComparative != null) this.formatDataForGraph();
      else {
        this.solutionComparatif = { structureTypesProject: [] };
      }
    } else {
      if (this.synthese) {
        this.solutions = this.synthese[0].solutions;
      }
      if (!this.defaultApplied && this.indicators.length > 0 && this.solutions?.length > 0) {
        this.defaultApplied = true;
        const coIndicator = this.indicators.find((i: Indicator) => i.code === IndicatorCodes.CO2);
        if (coIndicator) {
          coIndicator.isChecked = true;
          this.indicatorComparatif = coIndicator;
          this.selectedSolution = this.solutions[0].solutionId;
          this.changeSolution(this.selectedSolution);
        }
      }
    }
  }

  ngOnInit() {
    if (this.isEcoPro) {
      this.indicators = this.indicators.filter((indicator) => indicator.code == IndicatorCodes.CO2 || indicator.code == IndicatorCodes.Energie);
    }
  }

  selectSolutionChange(solutionEcoProId: any) {
    let solutionComparative: SolutionEcoPro | undefined = this.projectData?.solutionsEcoPro?.find((solution: SolutionEcoPro) => solution.solutionEcoProId == solutionEcoProId);
    if (solutionComparative) {
      this.solutionComparatif = solutionComparative;
      if (this.indicatorComparatif && this.solutionComparatif) this.formatDataForGraph();
    }
  }

  changeSolution(solutionId: string) {
    if (this.indicatorComparatif.displayName != '') {
      let specificSynthese = this.synthese.find((row: any) => row.code == this.indicatorComparatif.code);
      let solutionComparative = specificSynthese.solutions.find((solution: any) => solution.solutionId === solutionId);
      if (specificSynthese) {
        this.solutionComparatifProjet = solutionComparative;
        if (this.indicatorComparatif.displayName != '' && this.solutionComparatifProjet) {
          this.formatDataForGraph();
        }
      }
    }
  }
  onChangeIndicatorSelect(cb: MatCheckboxChange, indicator: Indicator) {
    this.indicators.forEach((i) => (i.isChecked = false));
    if (cb.checked) {
      indicator.isChecked = true;
      this.indicatorComparatif = indicator;
      if (this.indicatorComparatif.displayName != '') {
        if (Object.keys(this.solutionComparatifProjet).length === 0) {
          if (this.selectedSolution) {
            this.changeSolution(this.selectedSolution);
            this.formatDataForGraph();
          }
        } else {
          this.changeSolution(this.selectedSolution);
          this.formatDataForGraph();
        }
      }
    } else {
      this.indicatorComparatif = { isChecked: false, displayName: '' };
    }
  }

  formatDataForGraph() {
    let dataForGraph: {
      id: string;
      parent: string;
      name: string;
      value?: number;
      color?: string;
    }[] = [];
    let indexLevel_2: number = 1;
    let indexLevel_3: number = 2;

    // Indicateur : LEVEL 1

    if (this.indicatorComparatif) {
      dataForGraph.push({
        id: '0.0',
        parent: '',
        name: this.labelI18n.indicatorLabelWithUnit(this.indicatorComparatif)
      });
    }

    // Postes d'emission : LEVEL 2
    let specificSynthese = this.synthese.find((row: any) => row.code === this.indicatorComparatif.code);
    let stationImpact: Impact = {};
    if (this.solutionComparatifProjet.operations) {
      let headers;
      this.solutionComparatifProjet.operations.forEach((operation: any) => {
        dataForGraph.push({
          id: '1.' + indexLevel_2,
          parent: '0.0',
          name: `${operation.operationName}`,
          color: '#808080'
        });
        headers = this.generateArray(operation.values);
        headers.forEach((header: any) => {
          stationImpact = {};
          switch (header.key) {
            case SationImpactColor.BuildTransportCostIn.toString():
              stationImpact.value = parseFloat(header.value.replace(',', '.'));
              stationImpact.color = SationImpactColor.BuildTransportCostIn.value;
              stationImpact.displayName = specificSynthese.headers.BuildTransportCostIn;
              break;
            case SationImpactColor.MaterialMakingCost.toString():
              stationImpact.value = parseFloat(header.value.replace(',', '.'));
              stationImpact.displayName = specificSynthese.headers.MaterialMakingCost;
              stationImpact.color = SationImpactColor.MaterialMakingCost.value;
              break;
            case SationImpactColor.InitialTransportCost.toString():
              stationImpact.value = parseFloat(header.value.replace(',', '.'));
              stationImpact.displayName = specificSynthese.headers.InitialTransportCost;
              stationImpact.color = SationImpactColor.InitialTransportCost.value;
              break;
            case SationImpactColor.MaterialCost.toString():
              stationImpact.value = parseFloat(header.value.replace(',', '.'));
              stationImpact.displayName = specificSynthese.headers.MaterialCost;
              stationImpact.color = SationImpactColor.MaterialCost.value;
              break;
            case SationImpactColor.WorkingCost.toString():
              stationImpact.value = parseFloat(header.value.replace(',', '.'));
              stationImpact.displayName = specificSynthese.headers.WorkingCost;
              stationImpact.color = SationImpactColor.WorkingCost.value;
              break;
            case SationImpactColor.BuildTransportCostOut.toString():
              stationImpact.value = parseFloat(header.value.replace(',', '.'));
              stationImpact.displayName = specificSynthese.headers.BuildTransportCostOut;
              stationImpact.color = SationImpactColor.BuildTransportCostOut.value;
              break;
            default:
              break;
          }
          if (Object.keys(stationImpact).length !== 0) {
            dataForGraph.push({
              id: '2.' + indexLevel_3,
              parent: '1.' + indexLevel_2,
              name: `${stationImpact.displayName}`,
              color: `${stationImpact.color}`,
              value: stationImpact.value
            });
            indexLevel_3++;
          }
        });
        indexLevel_2++;
      });
    }

    this.chartOptions.series = [
      {
        type: 'sunburst',
        data: dataForGraph,
        tooltip: {
          valueDecimals: 2
        },
        cursor: 'pointer',
        dataLabels: {
          format: '{point.name}',
          filter: {
            property: 'innerArcLength',
            operator: '>',
            value: 16
          },
          rotationMode: 'circular'
        },
        levels: [
          {
            level: 1,
            color: 'white',
            levelIsConstant: false,
            dataLabels: {
              filter: {
                property: 'outerArcLength',
                operator: '>',
                value: 64
              }
            }
          },
          {
            level: 2,
            colorByPoint: true
          } as any
        ]
      }
    ];

    this.updateFlag = true;
    stationImpact = {};
  }

  generateArray(obj: any) {
    return Object.keys(obj).map((key) => {
      return { key: key, value: obj[key] };
    });
  }
}
